import { useEffect, useState } from "react";

const PackageOwnerInformation = ({title, packageInfo}) => {

    const [ownerName, setOwnerName] = useState([]);

    useEffect(() => {
        const filterArray = packageInfo.participants?.filter((data) => packageInfo.owners?.includes(data.id));
        setOwnerName(filterArray)
    }, [packageInfo])

    return (
        <>
            <div className="package-owner__container">
                <div className="package-owner__title">{title}</div>
				{ownerName.length > 0 && ownerName?.map((owner)=>(
					<div className="package-owner__name" key={owner.id}>{owner?.name}</div>
				))}
            </div>
        </>
    )

};

export default PackageOwnerInformation;
